import { useInstance } from 'react-ioc';
import { observer } from 'mobx-react-lite';

import { Store } from '../../model/store/Store';
import { TimeFormat } from '../../shared/TimeFormat';

import cls from '../Header/Header.module.scss';

export const Today = observer(() => {

    const {auth} = useInstance(Store)
    const mins = auth.data?.today!

    if (mins === 0) return null

    return <span className={cls.today}>{TimeFormat(mins)}</span>
})